"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var filter_1 = __importDefault(require("lodash/filter"));
var FutureEntitiesRepository = /** @class */ (function () {
    function FutureEntitiesRepository($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/future-entities",
            UPDATE: APPURL + "/api/v1/future-entities",
            CREATE: APPURL + "/api/v1/future-entities",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    FutureEntitiesRepository.prototype.extract = function (result) {
        return result.data;
    };
    FutureEntitiesRepository.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    FutureEntitiesRepository.prototype.destroy = function (data) {
        return this.$http
            .post(this.URLS.FETCH + "/deletes", data)
            .then(this.cacheResults);
    };
    FutureEntitiesRepository.prototype.show = function (data) {
        data = (0, filter_1.default)(data, function (entity) {
            if (entity.type === "Drive Session") {
                entity.private = "N";
            }
            return entity.type === "Drive Session";
        });
        var payload = {
            entities: data,
            private: "N",
        };
        return this.$http
            .post(this.URLS.FETCH, payload)
            .then(this.cacheResults);
    };
    FutureEntitiesRepository.prototype.hide = function (data) {
        data = (0, filter_1.default)(data, function (entity) {
            if (entity.type === "Drive Session") {
                entity.private = "Y";
            }
            return entity.type === "Drive Session";
        });
        var payload = {
            entities: data,
            private: "Y",
        };
        return this.$http
            .post(this.URLS.FETCH, payload)
            .then(this.cacheResults);
    };
    FutureEntitiesRepository.prototype.reassign = function (data) {
        return this.$http
            .post(this.URLS.FETCH, data)
            .then(this.cacheResults);
    };
    return FutureEntitiesRepository;
}());
FutureEntitiesRepository.$inject = ["$http", "APPURL"];
exports.default = FutureEntitiesRepository;
